import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_332: DocMigration = {
  maxSchemaVersion: "0.0.332",
  description: "Remove orphaned content template instances for plan set templates",
  apply(json: any) {
    const orphanedInstanceIds = new Set<string>();

    for (const id in json.contentTemplateInstances) {
      if (!json.entityRefs[id]) {
        continue;
      }

      const instance = json.contentTemplateInstances[id];

      const instanceContentTemplate = json.contentTemplates[instance.contentTemplateId];

      if (!instanceContentTemplate) {
        console.warn(
          `Orphaned content template instance ${instance.name} - ${id} has no corresponding instance content template. Removing instance...`,
        );
        orphanedInstanceIds.add(id);
      }

      const instancePlanSetTemplate = json.planSetTemplates[instance.contentTemplateId];

      if (!instancePlanSetTemplate) {
        console.warn(
          `Orphaned content template instance ${instance.name} - ${id} has no corresponding instance plan set template. Removing instance...`,
        );
        orphanedInstanceIds.add(id);
      }

      const instanceContentTemplateParent = json.contentTemplates[instance.parentId];

      if (!instanceContentTemplateParent) {
        console.warn(
          `Orphaned content template instance ${instance.name} - ${id} has no corresponding parent content template. Removing instance...`,
        );
        orphanedInstanceIds.add(id);
      }

      const instancePlanSetTemplateParent = json.planSetTemplates[instance.parentId];

      if (!instancePlanSetTemplateParent) {
        console.warn(
          `Orphaned content template instance ${instance.name} - ${id} has no corresponding parent plan set template. Removing instance...`,
        );
        orphanedInstanceIds.add(id);
      }
    }

    for (const id of orphanedInstanceIds) {
      delete json.contentTemplateInstances[id];
    }

    return json;
  },
};

export default migration_0_0_332;
